import { INVALID_PROFILE_URL_KEY } from 'core/constants/exceptions'
import toastNotification from 'pug/toastNotification'
import getURLParams from 'utils/DOM/getURLParams'
import innerHTML from 'utils/DOM/innerHTML'
import { INVALID_PROFILE } from 'messages'
import updateFormData from './controller'
import {
  IS_AGENT,
  IS_DENTAL_AND_VISION,
  IS_FIXED_BENEFIT_MEDICAL
} from 'core/constants/environment'
import loadJornayaScript from 'pug/mixins/jornaya/loadScript'
import visitedPlans from 'sites/enroll.pivothealth.com/quotes/components/compare/visitedPlans'
import { MAX_PLANS_TO_COMPARE } from 'core/constants/compareNumberPlans'
import toggleClass from 'utils/DOM/toggleClass'
import { IS_SHORT_TERM } from 'core/constants/environment'
import { updateProductInformation } from './controller/index'
import registerListenersDOM from './registerListenersDOM'
import { enableMultiCarrierPlans } from 'utils/experiments'
import removeElements from 'utils/DOM/removeElements'

const urlParams = getURLParams()

function initDOM({ hcStorage }) {
  // Setup GTM and add userId to dataLayer
  window.dataLayerPushVariable({
    user_id: hcStorage.healthcareUserId
  })
  // window.hc.smartlySDK is used safely because initPage() was executed before
  const smartlySDK = window.hc.smartlySDK
  if (smartlySDK) {
    smartlySDK.track('ph_display_census')
    smartlySDK.publish()
  }
  toggleClass(document.body, 'fbm', IS_FIXED_BENEFIT_MEDICAL)

  visitedPlans.init(hcStorage.healthcareSession, MAX_PLANS_TO_COMPARE)
  visitedPlans.removeAllPlans()

  if (IS_DENTAL_AND_VISION && !IS_AGENT) {
    loadJornayaScript()
  }

  if (urlParams.notification === INVALID_PROFILE_URL_KEY) {
    toastNotification(INVALID_PROFILE)
  }

  $('#btm-modal').modal({ show: false })

  if (urlParams.backTo) {
    innerHTML('.primaryButton', 'Update My Profile <i class="hc-icon-angle-right" />')
  }

  updateFormData(hcStorage)

  // Is STM product
  if (IS_SHORT_TERM) {
    updateProductInformation('stm')
    toggleClass('#wrap-period', 'd-none', false)
  }

  registerListenersDOM()

  if (!enableMultiCarrierPlans()) {
    removeElements('.d-hidden-php-fn')
  }
}

export default initDOM
